import { Creators } from "./model"
import createModule from "../createModule"
import view from "./view"
import { getContentSets } from "selectors/securities-table"
import { getSelectedDate, getAllRules, getTabOrder } from "./selectors"
import { getSmartTradePositionSet } from "modules/smart-trade/selectors"
import { getModelId } from "modules/smart-trade/selectors/model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getSelectedExperiment } from "modules/smart-trade-panel/selectors/utils"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    modelId: getModelId(state),
    selectedExperiment: getSelectedExperiment(state, props),
    selectedDate: getSelectedDate(state, props),
    smartTradePositionSet: getSmartTradePositionSet(state, props),
    contentSets: getContentSets(state, props),
  }),
  required: ["selectedDate", "modelId", "smartTradePositionSet"],
  data: [
    {
      resource: "modelCountries",
      as: null,
      url: ({ account, modelId }) => `/api/${account}/m/${modelId}/countries`,
    }, {
      resource: "modelCurrencies",
      as: null,
      url: ({ account, modelId }) => `/api/${account}/m/${modelId}/currencies`,
    },
    MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    tabOrder: getTabOrder(state, props),
    allRules: getAllRules(state, props),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
  },
})
